// extracted by mini-css-extract-plugin
module.exports = {"secondary":"DisplayUsername_secondary__0dys9","primary":"DisplayUsername_primary___WxJN"};